import React, { useEffect, useState, useContext } from 'react';
import { postTcardLinkedToJob, TCards_SerachJobs } from '../../../../Core/Service/checkInRole';
import { Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Grid, FormLabel, Typography } from '@material-ui/core';
import { PrimaryButton, SecondaryButton, SelectBox, TextBox } from '../../../../Core/FormInput';
import DialogActions from '@material-ui/core/DialogActions';
import AppContext from '../../../../App/AppContext';
import { withStyles, makeStyles } from '@material-ui/core/styles';
// import { getTcardBranchData } from '../../../../Core/Service/TCardDashboard-service';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'lightgray',
        color: 'black',
        fontSize: 16,
        fontWeight: 'bold'
    },
    body: {
        fontSize: 14,
        padding: '5px 12px'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover
        }
    }
}))(TableRow);

const useStyles = makeStyles({
    table: {
        minWidth: 700,
        border: '1px solid lightgrey',
        minHeight: '100% !important'
    },
    container: {
        maxHeight: 440
    }
});

const LinkTCardToJob = (props) => {
    const { BranchID, CustomerName, RegistrationNumber, tCardsID, branchName } = props;

    const [state, setState] = useState({
        loading: true,
        jobs: [],
        BranchID: BranchID || null,
        CustomerName: CustomerName,
        RegistrationNumber: RegistrationNumber,
        BranchesList: [],
        selectedHeaderId: null
    });

    const { showToast } = useContext(AppContext);
    const classes = useStyles();

    const history = useHistory();
    useEffect(() => {
        setState((st) => ({
            ...st,
            BranchID: BranchID,
            CustomerName: CustomerName,
            RegistrationNumber: RegistrationNumber
        }));
    }, [props]);

    // useEffect(() => {
    //     let fetchData = async () => {
    //         let res = await getTcardBranchData();
    //         if (res.success) {
    //             setState((st) => ({
    //                 ...st,
    //                 BranchesList: res?.data?.branches || []
    //             }));
    //         }
    //     };
    //     return fetchData();
    // }, []);

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            try {
                let rec = await TCards_SerachJobs(state.RegistrationNumber, state.BranchID, state.CustomerName);

                if (isMounted) {
                    if (rec.success) {
                        setState((st) => ({ ...st, jobs: rec.data?.jobs?.map((j) => ({ ...j, isSelected: false })) || [], loading: false }));
                    } else {
                        console.error('API response unsuccessful:', rec);
                        setState({ jobs: [], loading: false });
                    }
                }
            } catch (error) {
                console.error('Error fetching jobs:', error);
                if (isMounted) setState({ jobs: [], loading: false });
            }
        };

        fetchData();
        return () => {
            isMounted = false;
        };
    }, [state.RegistrationNumber, state.BranchID, state.CustomerName]);

    const onJobSelect = (checked, jobHeaderId) => {
        setState((st) => {
            let newSt = { ...st };
            let job = newSt.jobs.find((d) => d.headerRecordID === jobHeaderId);
            if (job) {
                newSt.jobs.forEach((d) => (d.isSelected = false));
                job.isSelected = checked;
                newSt.selectedHeaderId = checked ? jobHeaderId : undefined;
                newSt.jobs = [...newSt.jobs];
            }
            return newSt;
        });
    };
    const processDocMovement = async () => {
        if (state.selectedHeaderId) {
            let res = await postTcardLinkedToJob(tCardsID, state.selectedHeaderId);
            if (res.success) {
                showToast(res?.data?.message);
                props.onClose(true);
            }
        }
    };

    const fieldChange = (e) => {
        const { name, value } = e.target;
        setState((st) => {
            const nst = { ...st, [name]: value };
            return nst;
        });
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ margin: 10 }}>
                <Grid container spacing={2}>
                    {/*  <Grid item xs={4} md={4} lg={4}>
                        <FormLabel component="legend">Branch</FormLabel>
                        <SelectBox disabled={true} List={state.BranchesList || []} onChange={fieldChange} value={state.BranchID} name="BranchID" />
                    </Grid>
                    <Grid item xs={3} md={4} lg={4}>
                        <FormLabel component="legend">Registration Number</FormLabel>
                        <TextBox
                            style={{ marginTop: 1 }}
                            disabled={true}
                            placeholder="Registration Number"
                            required={false}
                            name="RegistrationNumber"
                            onChange={fieldChange}
                            value={state.RegistrationNumber}
                        />
                    </Grid>
                    <Grid item xs={5} md={4} lg={4}>
                        <FormLabel component="legend">Customer Name</FormLabel>
                        <TextBox
                            style={{ marginTop: 1 }}
                            disabled={true}
                            placeholder="Customer Name"
                            required={false}
                            onChange={fieldChange}
                            value={state.CustomerName}
                            name="CustomerName"
                        />
                    </Grid>*/}
                    <Grid item lg={4}>
                        Branch
                        <Typography variant="body1">
                            <b>{branchName}</b>
                        </Typography>
                    </Grid>
                    <Grid item lg={4}>
                        Reg
                        <Typography variant="body1">
                            <b>{RegistrationNumber}</b>
                        </Typography>
                    </Grid>
                    <Grid item lg={4}>
                        CustomerName
                        <Typography variant="body1">
                            <b>{CustomerName}</b>
                        </Typography>
                    </Grid>
                </Grid>
                <TableContainer className="custom-scroll" style={{ maxHeight: 'calc(100vh - 395px)', minHeight: '270px' }}>
                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell width="2%">&nbsp;</StyledTableCell>
                                <StyledTableCell width="5%" align="center">
                                    WIP
                                </StyledTableCell>
                                <StyledTableCell width="43%" align="center">
                                    Customer
                                </StyledTableCell>
                                <StyledTableCell width="40%" align="center">
                                    Due In
                                </StyledTableCell>
                                <StyledTableCell width="10%" align="center">
                                    Workflow
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {state.loading ? null : state.jobs.length > 0 ? (
                                state.jobs.map((m) => (
                                    <StyledTableRow key={m.id}>
                                        <StyledTableCell component="th" scope="row" style={{ paddingLeft: 16 }}>
                                            <Checkbox
                                                checked={m.isSelected}
                                                color={m.isSelected ? 'primary' : ''}
                                                onChange={(e) => onJobSelect(e.target.checked, m.headerRecordID)}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell align="center">{m.wipNumber}</StyledTableCell>
                                        <StyledTableCell align="center">{m.customer}</StyledTableCell>
                                        <StyledTableCell align="center">{m.dateDueIn}</StyledTableCell>
                                        <StyledTableCell align="center">{m.workflow}</StyledTableCell>
                                    </StyledTableRow>
                                ))
                            ) : (
                                <StyledTableRow>
                                    <StyledTableCell align="center" colSpan={5}>
                                        <div style={{ marginLeft: 30 }}>No Jobs Found</div>
                                    </StyledTableCell>
                                </StyledTableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <DialogActions>
                <SecondaryButton onClick={() => props.onClose(false)}>Cancel</SecondaryButton>
                {!props.isReadOnly && (
                    <PrimaryButton onClick={processDocMovement} disabled={!state.selectedHeaderId}>
                        Link Job
                    </PrimaryButton>
                )}
            </DialogActions>
        </div>
    );
};

export default LinkTCardToJob;
